import React from 'react';
import ReactPaginate from 'react-paginate';
import './Pagination.css';

const Pagination = ({ totalPage, currentPage, handlePageChange }) => {
  return (
    <ReactPaginate
      previousLabel="Prev"
      nextLabel="Next"
      breakLabel="..."
      pageCount={Number.isInteger(totalPage) ? totalPage : 1}
      forcePage={currentPage}
      marginPagesDisplayed={2}
      pageRangeDisplayed={5}
      onPageChange={handlePageChange}
      containerClassName="pagination mt-3"
      activeClassName="active"
    />
  );
};

export default Pagination;
